<template>
  <SogCard>
    <SogCardTitle>Schaden</SogCardTitle>
    <!--
        <SogCardContent>
          <SogButton> über Schadenmeldung</SogButton>
        </SogCardContent>
    -->
    <SogCardContent>&nbsp;</SogCardContent>
    <SogCardActions>
      <SogCardActionButton @click="onClaim">
        Schaden melden
      </SogCardActionButton>
    </SogCardActions>
  </SogCard>
</template>

<script setup lang="ts">

import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {useRouter} from "vue-router";


const _router = useRouter()


function onClaim() {
  _router.push("/schaden")
}


</script>

<style scoped>

</style>
